import { OPERATION_EXPORT_ADVERTISEMENTS } from '../use-advertisements'
import { useQueryVariables } from '../store'
import Export from 'components/global/Modals/Export'

const AdvertisementsExport = () => {
  const queryVariables = useQueryVariables()

  return (
    <Export
      title="advertisements.export.title"
      formats={[
        { type: 'xlsx', icon: 'fa-file', label: 'advertisements.export.xlsx' },
        { type: 'csv', icon: 'fa-file-csv', label: 'advertisements.export.csv' }
      ]}
      query={OPERATION_EXPORT_ADVERTISEMENTS}
      variables={queryVariables}
      exportFieldName="exportPortalAdvertisements"
    />
  )
}

export default AdvertisementsExport
